// Inspired by: http://www.davidflanagan.com/2009/08/typeof-isfuncti.html
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var forEach = Array.prototype.forEach.bind([]);

module.exports = function (obj) {
  var type;

  if (!obj) {
    return false;
  }

  type = _typeof(obj);

  if (type === 'function') {
    return true;
  }

  if (type !== 'object') {
    return false;
  }

  try {
    forEach(obj);
    return true;
  } catch (e) {
    if (e instanceof TypeError) {
      return false;
    }

    throw e;
  }
};